import { useState, useEffect, useCallback } from 'react';
import { DashboardActivityResponse, dashboardService, DashboardSummaryResponse } from '../services/dashboard.service';


interface UseDashboardReturn {
  summary: DashboardSummaryResponse | null;
  activity: DashboardActivityResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useDashboard(): UseDashboardReturn {
  const [summary, setSummary] = useState<DashboardSummaryResponse | null>(null);
  const [activity, setActivity] = useState<DashboardActivityResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [summaryRes, activityRes] = await Promise.all([
        dashboardService.getSummary(),
        dashboardService.getActivity(15),
      ]);
      setSummary(summaryRes);
      setActivity(activityRes);
    } catch (err: any) {
      console.error('Dashboard fetch error:', err);
      setError(err?.message || 'Error loading dashboard data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { summary, activity, loading, error, refresh: fetchData };
}